import React, { Children, lazy, Suspense, useContext, useEffect, useState } from 'react';
export const IsTourOpenContext = React.createContext({
  isTourOpen: false,
  setIsTourOpen: (value: boolean) => { },
});
export default function IsTourOpenProvider({ children }: any) {
  const [isTourOpen, setIsTourOpen] = useState(false);
  return (
    <IsTourOpenContext.Provider value={{ isTourOpen, setIsTourOpen }}>
      {children}
    </IsTourOpenContext.Provider>
  );
}
